import React from "react";
import AdminInsolvencyCasePage from "./AdminInsolvencyCasePage";

const AdminGangaPage = () => (
  <AdminInsolvencyCasePage
    slug="ganga"
    title="Ganga Foundations - Content Management"
    color="#667eea"
  />
);

export default AdminGangaPage;
